export type Layout =
    | 'empty'
    | 'auth'
    // Horizontal
    | 'centered'
    | 'enterprise'
    | 'material'
    | 'modern'
    //Vertical
    | 'classic'
    | 'classy'
    | 'compact'
    | 'dense'
    | 'futuristic'
    | 'thin';
